<template>
  <el-dialog :title="getTitle"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="roomInfo"
               :rules="roomRules"
               ref="roomForm"
               label-width="100px"
               class="room-form">
        <el-form-item label="所属父级："
                      prop="area_id">
          <el-select v-model="roomInfo.area_id"
                     placeholder="请选择所属父级">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :disabled="item.area_type === 'area_type_no'"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房屋ID:"
                      prop="house_id">
          <el-input v-model.trim="roomInfo.house_id"
                    placeholder="请输入房屋ID"></el-input>
        </el-form-item>
        <!--
        <el-form-item label="小区："
                      prop="community">
          <el-input v-model.trim="roomInfo.community"
                    placeholder="请输入小区"></el-input>
        </el-form-item>
        <el-form-item label="楼号："
                      prop="building">
          <el-input v-model.trim="roomInfo.building"
                    placeholder="请输入楼号"></el-input>
        </el-form-item>
        <el-form-item label="单元："
                      prop="unit">
          <el-input v-model.trim="roomInfo.unit"
                    placeholder="请输入单元"></el-input>
        </el-form-item>
        -->
        <el-form-item label="房间名称："
                      prop="name">
          <el-input v-model.trim="roomInfo.name"
                    placeholder="请输入房间名称"></el-input>
        </el-form-item>
        <el-form-item label="房间类型："
                      prop="room_type_id">
          <el-select v-model="roomInfo.room_type_id"
                     placeholder="请选择房间类型">
            <el-option v-for="item in roomList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注："
                      prop="remarks">
          <el-input type="textarea"
                    v-model.trim="roomInfo.remarks"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/room/add' || '/room/edit'"
                 type="primary"
                 @click="handleConfirm('roomForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      from: this.data.type,
      showModal: this.isShow,
      roomInfo: {
        area_id: '',
        house_id: '',
        community: '',
        building: '',
        unit: '',
        name: '',
        room_type_id: '',
        remarks: ''
      },
      roomRules: {
        house_id: [{ required: true, message: '请输入房屋ID' }],
        area_id: [{ required: true, message: '请选择所属楼宇' }],
        name: [{ required: true, message: '请输入房间名称' }],
        room_type_id: [{ required: true, message: '请选择房间类型' }]
      },
      areaList: [],
      roomList: [],
      tmpArr: []
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加房间' : '编辑房间'
    }
  },
  created() {
    this.getAreaTree()
    this.getRoomTypeList()
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getRoomInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomInfo = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取机构下拉
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取房型
    getRoomTypeList() {
      fetch.getRoomTypeList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addRoom({ ...this.roomInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editRoom({ ...this.roomInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style></style>
